import { render, staticRenderFns } from "./VesselPreview.vue?vue&type=template&id=2eea1584&"
import script from "./VesselPreview.vue?vue&type=script&lang=js&"
export * from "./VesselPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports